// extracted by mini-css-extract-plugin
export default {"periodsContainer":"week_periods-module___periodsContainer___c9bbfcef"};